import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { Job } from '@/class/model/booking/Job'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { StatusChangeHistory } from '@/class/model/booking/StatusChangeHistory'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import { isArray } from '@/utils/validate'
import StrUtils from '@/utils/StrUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import $store from '@/store'
import { queryIsInsured } from '@/api/external/insure'
import ColumnUtils from '@/utils/ColumnUtils'
import { manualTriggerAndUpate, updateReleasestate } from '@/api/seaExport/seaExportJob'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as AutomaticReleaseConstants from '@/class/cargo/model/parameters/AutomaticReleaseConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { cancelRequestRelease, requestRelease, executeRuleEngine } from '@/api/seaExport/seaCargoDoc'
import { cache } from '@/utils/cacheManager'
import { addMailingAddress, queryPaymentAddressFunc } from '@/api/partner/mailingAddress'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DOC_PAGE_SOURCE } from '@/class/cargo/model/parameters/SystemConstants'
import { Message } from '@/utils/Message'
import { getInitialDocHsCode } from './seaHsCodeMode'

export class TabMBLPM {
  /**
 * @param {Object} view 视图
 */
  constructor(view) {
    this.view = view
    this.$message = view.$message || Message
    this.useMscEDICarriers = '' // 开启Msc EDI信息的船公司(','符号分割的键值对，key-scac code,value-是否开启)
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.otherField = 'alsoNotify'
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode // 是否同步收发通代码到基本页签
    this._valueType = undefined
    this._editWindow = null
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  init() {
    this.useMscEDICarriers = this.config.get('useMSCEDI')
    this.view.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars')) || 45
    this.view.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor')) || 35
    // 从配置中读取英文品名最大字符数
    const maxChars = Number(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
    if (maxChars > 0) {
      this.view.englishNameMaxChars = maxChars
    }
    // 从配置中读取唛头最大字符数
    const maxChars2 = Number(this.config.get('SEMarkMaxChars'))
    if (maxChars2 > 0) {
      this.view.markMaxChars = maxChars2
    }
    // 从配置中读取海运出口MBL英文品名标红字符数
    const maxColor = Number(this.config.get('SEEnglishDescriptionOfGoodWarningColor'))
    if (maxColor > 0) {
      this.view.englishNameWarningCount = maxColor
    }
    // 从配置中读取海运出口MBL唛头标红字符数
    const maxColor2 = Number(this.config.get('SEMarkWarningColor'))
    if (maxColor2 > 0) {
      this.view.markWarningCount = maxColor2
    }
    getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm).then(data => {
      this.paymentTermList = data
    })
    getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
      for (const item of data) {
        if (item.blType === 1) {
          this.view.blModeList.push(item)
        }
      }
    })
    getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
      this.packingList = data
    })
  }
  async changeJob() {
    const job = new SeaExportJob(this.job)
    this.job.jointMasterMBL = await job.getJointMasterMBL()
    const cargoDoc = await job.getSeaCargoDoc()
    await this.loadCargoDoc2Handler(cargoDoc)
    this.job.typeMBL = this.job.typeMBL || 1
    this.refreshVessel()
  }
  async fillView() {
    this.carrierIsOpenMscEDI()
    this.initOtherField()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code ||
        this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      await this.loadCheckDocs()
    }
  }
  /**
   * 获取最近修改的对单记录
   */
  async loadCheckDocs() {
    const checkDocHistories = await CheckCargoDocHistory.queryDocHistoryByTime(this.form.uuid)
    this.queryTopCheckDocHistoriesHandler(checkDocHistories)
  }
  queryTopCheckDocHistoriesHandler(checkDocHistories) {
    this.comparedCargoDocIsModified(checkDocHistories)
  }
  /**
   * 对单后把有修改的内容显示红色
   */
  comparedCargoDocIsModified(checkDocHistories) {
    if (checkDocHistories && checkDocHistories.length > 0) {
      const variableCss = this.view.variableCss
      // 获取对单记录的第一条记录，根据是否有标识字段判断是否对单时修改了字段,有字段修改的情况去改变字段颜色
      const firstCheckDaoHistory = checkDocHistories[0]
      if (firstCheckDaoHistory.fieldName !== 'noChange') {
        for (const checkDocHistory of checkDocHistories) {
          const fieldName = checkDocHistory.fieldName
          if (variableCss.hasOwnProperty(fieldName)) {
            if (fieldName === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
              continue
            } else if (fieldName === 'mark' && this.form.mark.length >= 22) {
              continue
            }
            this.checkHistoryTextMapChanged(checkDocHistory, checkDocHistories)
          }
        }
      }
    }
  }
  /**
   * 对单内容
   */
  checkHistoryTextMapChanged(checkDocHistory, checkDocHistories) {
    switch (checkDocHistory.fieldName) {
      case 'shipperLine':
        this.checkHistoryByShipperConsigneeNotifyLine('shipperLineOld', 'shipperLine', checkDocHistory, checkDocHistories)
        break
      case 'consigneeLine':
        this.checkHistoryByShipperConsigneeNotifyLine('consigneeLineOld', 'consigneeLine', checkDocHistory, checkDocHistories)
        break
      case 'notifyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('notifyLineOld', 'notifyLine', checkDocHistory, checkDocHistories)
        break
      default:
        this.view.variableCss[checkDocHistory.fieldName] = 'red'
        break
    }
  }
  /**
   * 检查收发通知人是否发生变化
   */
  checkHistoryByShipperConsigneeNotifyLine(oldField, textField, checkDocHistory, checkDocHistories) {
    const line = checkDocHistory.fieldValue
    const oldLine = this.getDocHistoryShipperConsigneeNotify(oldField, checkDocHistories)
    const lines = line.split('|')
    const oldLines = oldLine.split('|')
    for (let i = 0; i < lines.length; ++i) {
      const index = i + 1
      const line2 = lines[i].replace('\r\n', '')
      const lineOld2 = oldLines[i].replace('\r\n', '')
      if (line2 !== lineOld2) {
        this.view.variableCss[textField] = 'red'
        this.view.variableCss[textField + index] = 'red'
      }
    }
  }
  /**
   * 获取上一个版本收发通历史的数据
   */
  getDocHistoryShipperConsigneeNotify(fieldName, checkDocHistories) {
    for (let i = 0; i < checkDocHistories.length; i++) {
      if (checkDocHistories[i].fieldName === fieldName) {
        return checkDocHistories[i].fieldValue
      }
    }
    return ''
  }
  /**
   * 重置对单颜色
   */
  resetColor() {
    for (const key in this.view.variableCss) {
      if (key === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
        continue
      } else if (key === 'mark' && this.form.mark.length >= 22) {
        continue
      }
      this.view.variableCss[key] = ''
    }
  }
  fillModel() {
    this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)
    this.view.$store.dispatch('log/addLog', {
      type: 'info',
      msg: 'mbl:' + this.form,
      url: window.location.href
    })
    // 提单发货地
    this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 提单目的地
    this.form.destinationPlace = this.form.destinationPlace.toUpperCase()
    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    // 箱重大写
    this.form.signPlaceBL = this.form.signPlaceBL.toUpperCase()
    // 英文品名
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // 唛头
    // this.form.mark = this.form.mark.toUpperCase()
    this.form.state = this.form.state || 1
    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()
    this.form.cargoManifestName = this.form.cargoManifestName.toUpperCase()
    this.form[this.otherField + 'Code'] = this.view.otherCode
    // 处理特殊字符
    JobUtils.handlingSpecialCharactersForCargoDoc(this.form)
  }
  print() {
    // if (view.job) {
    //   var params: Object = new Object()
    //   params.jobuuid = view.job.key
    //   params.cargoDocUuid = view.cargoDoc.key
    //   params.DOC_UUID = view.cargoDoc.key
    //   TemplateSelectorWin.getInstance().showThisWin(view.job, 'MBL', params, view, null, printedCallback, v2CheckCallbackFun)
    // }
  }
  /**
   * V1打印反馈
   */
  printedCallback(evt = null) {
    // Tracking.updateTrackingByEvent(view.job.key, TrackingConstants.TRIGGER_PRINT_MBL.code, new mx.rpc.Responder(function (e) { }, view.faultHandler))
  }
  /**
   * V2打印反馈
   */
  v2CheckCallbackFun(printed, template, entity, params) {
    // if (printed) {
    //   printedCallback()
    // }
  }
  executeTask() {
    DocCommon.MBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.MBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.MBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.MBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.MBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.MBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.MBL_History.shipperCode = this.form.shipperCode
    DocCommon.MBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.MBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.MBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.MBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.MBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.MBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.MBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.MBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.MBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.MBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.MBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.MBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.MBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.MBL_History.notifyCode = this.form.notifyCode
    DocCommon.MBL_History.dgconsignLine1 = this.form.dgconsignLine1
    DocCommon.MBL_History.dgconsignLine2 = this.form.dgconsignLine2
    DocCommon.MBL_History.dgconsignLine3 = this.form.dgconsignLine3
    DocCommon.MBL_History.dgconsignLine4 = this.form.dgconsignLine4
    DocCommon.MBL_History.dgconsignLine5 = this.form.dgconsignLine5
    DocCommon.MBL_History.dgconsignLine6 = this.form.dgconsignLine6
    DocCommon.MBL_History.elseInvoiceLine1 = this.form.elseInvoiceLine1
    DocCommon.MBL_History.elseInvoiceLine2 = this.form.elseInvoiceLine2
    DocCommon.MBL_History.elseInvoiceLine3 = this.form.elseInvoiceLine3
    DocCommon.MBL_History.elseInvoiceLine4 = this.form.elseInvoiceLine4
    DocCommon.MBL_History.elseInvoiceLine5 = this.form.elseInvoiceLine5
    DocCommon.MBL_History.elseInvoiceLine6 = this.form.elseInvoiceLine6
    DocCommon.MBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.MBL_History.mark = this.form.mark

    this.view.addrPM.isMBL = true
    this.view.addrPM.copyAddrType = 'MBL'
    this.view.addrPM.job = this.job
    this.view.addrPM.shipperCodeField = ''
    this.view.addrPM.shipperField = 'shipperLine'
    this.view.addrPM.consigneeCodeField = ''
    this.view.addrPM.consigneeField = 'consigneeLine'
    this.view.addrPM.notifyCodeField = ''
    this.view.addrPM.notifyField = 'notifyLine'
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.saveCheck()
    }
    // 同步主票提单信息
    // if (view.job != null && !view.job.isNewInstance() && view.job.isMasterFlag) {
    //   view.job.reloadCargoDoc2(loadCargoDoc2Handler, view.faultHandler)
    // }
  }
  async loadCargoDoc2Handler(cargoDocList) {
    if (!cargoDocList) {
      cargoDocList = this.job.seaCargoDoc
    }
    this.form = null
    if (cargoDocList.length > 0) {
      for (const doc1 of cargoDocList) {
        if (doc1.docType === 'MBL') {
          this.form = doc1
          break
        }
      }
      if (this.job.typeMBL === 2) {
        for (const doc2 of cargoDocList) {
          if (doc2.docType === 'MBL2') {
            this.view.cmbtypeMBLDisabled = true
            break
          }
        }
      }
    }
    if (!this.form) {
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      await SeaCargoDoc.copyInfoFromSeaExportJob(this.job, this.form)
      this.form.docType = 'MBL'
      this.form.edi = true
      this.form.jobUuid = this.job.uuid
      const seHsCodeMode = this.config ? Number(this.config.get('SEHSCodeMode')) : 0
      this.form.hsCode = getInitialDocHsCode({ jobHsCode: this.job.hsCode, seHsCodeMode })
      cargoDocList.push(this.form)
    } else {
      if (this.form.pageSource === DOC_PAGE_SOURCE) {
        // 暂时不用 copyInfoFromSeaExportJob
        await SeaCargoDoc.copyInfoFromJobPort(this.job, this.form)
      }
    }
    if (this.view.isEdit && !this.form.blCopyNumber) {
      if (this.form.releaseType === 1) {
        this.form.blCopyNumber = 'THREE'
      } else {
        this.form.blCopyNumber = 'ONE'
      }
    }
    if (!this.form.uuid) {
      this.form.edi = true
    }
    await this.editingChanged()
    this.showScac()
    this.getDocCfmState()
  }

  /**
   * MBL拆单列表存在数据时，MBL页签的提单种类要置灰；
   */
  async isEditTypeMbl() {
    if (!cargoDocList || cargoDocList.length <= 0) {
      await new SeaExportJob(this.job).getSeaCargoDoc()
    }
    const cargoDocList = this.job.seaCargoDoc
    if (cargoDocList && cargoDocList.length > 0) {
      if (this.job.typeMBL === 2) {
        for (const doc of cargoDocList) {
          if (doc.docType === 'MBL2' && !doc.deleted) {
            this.view.cmbtypeMBLDisabled = true
            break
          }
        }
      }
    }
  }

  /**
   * 编辑修改
   */
  async loadJointSlaves2Handler() {
    const job = new SeaExportJob(this.job)
    const jointSlavesMBL = await job.getJointSlavesMBL()
    if (jointSlavesMBL && jointSlavesMBL.length > 0) {
      this.view.cmbtypeMBLDisabled = true
    } else {
      this.view.cmbtypeMBLDisabled = !this.view.isEdit
    }
    await this.isEditTypeMbl()
  }
  /**
   * change printParam6
   */
  printParam6Change() {
    this.refreshVessel()
  }
  onCopy1() {
    this.form.shipperCode = DocCommon.MBL_History.shipperCode || ''
    this.form.shipperLine1 = DocCommon.MBL_History.shipperLine1 || ''
    this.form.shipperLine2 = DocCommon.MBL_History.shipperLine2 || ''
    this.form.shipperLine3 = DocCommon.MBL_History.shipperLine3 || ''
    this.form.shipperLine4 = DocCommon.MBL_History.shipperLine4 || ''
    this.form.shipperLine5 = DocCommon.MBL_History.shipperLine5 || ''
    this.form.shipperLine6 = DocCommon.MBL_History.shipperLine6 || ''
    this.form.consigneeCode = DocCommon.MBL_History.consigneeCode || ''
    this.form.consigneeLine1 = DocCommon.MBL_History.consigneeLine1 || ''
    this.form.consigneeLine2 = DocCommon.MBL_History.consigneeLine2 || ''
    this.form.consigneeLine3 = DocCommon.MBL_History.consigneeLine3 || ''
    this.form.consigneeLine4 = DocCommon.MBL_History.consigneeLine4 || ''
    this.form.consigneeLine5 = DocCommon.MBL_History.consigneeLine5 || ''
    this.form.consigneeLine6 = DocCommon.MBL_History.consigneeLine6 || ''
    this.form.notifyCode = DocCommon.MBL_History.notifyCode || ''
    this.form.notifyLine1 = DocCommon.MBL_History.notifyLine1 || ''
    this.form.notifyLine2 = DocCommon.MBL_History.notifyLine2 || ''
    this.form.notifyLine3 = DocCommon.MBL_History.notifyLine3 || ''
    this.form.notifyLine4 = DocCommon.MBL_History.notifyLine4 || ''
    this.form.notifyLine5 = DocCommon.MBL_History.notifyLine5 || ''
    this.form.notifyLine6 = DocCommon.MBL_History.notifyLine6 || ''
    this.form.cargoEnglishName = DocCommon.MBL_History.englishCargoName || ''
    this.form.mark = DocCommon.MBL_History.mark || ''
  }
  selectionItemHandler(rows) {
    const selectedMBL = isArray(rows) ? rows[0] : rows
    if (selectedMBL) {
      this.form.shipperCode = selectedMBL.shipperCode
      this.form.shipperLine1 = selectedMBL.shipperLine1
      this.form.shipperLine2 = selectedMBL.shipperLine2
      this.form.shipperLine3 = selectedMBL.shipperLine3
      this.form.shipperLine4 = selectedMBL.shipperLine4
      this.form.shipperLine5 = selectedMBL.shipperLine5
      this.form.shipperLine6 = selectedMBL.shipperLine6
      this.form.shipperLine7 = selectedMBL.shipperLine7
      this.form.consigneeCode = selectedMBL.consigneeCode
      this.form.consigneeLine1 = selectedMBL.consigneeLine1
      this.form.consigneeLine2 = selectedMBL.consigneeLine2
      this.form.consigneeLine3 = selectedMBL.consigneeLine3
      this.form.consigneeLine4 = selectedMBL.consigneeLine4
      this.form.consigneeLine5 = selectedMBL.consigneeLine5
      this.form.consigneeLine6 = selectedMBL.consigneeLine6
      this.form.consigneeLine7 = selectedMBL.consigneeLine7
      this.form.notifyCode = selectedMBL.notifyCode
      this.form.notifyLine1 = selectedMBL.notifyLine1
      this.form.notifyLine2 = selectedMBL.notifyLine2
      this.form.notifyLine3 = selectedMBL.notifyLine3
      this.form.notifyLine4 = selectedMBL.notifyLine4
      this.form.notifyLine5 = selectedMBL.notifyLine5
      this.form.notifyLine6 = selectedMBL.notifyLine6
      this.form.notifyLine7 = selectedMBL.notifyLine7
      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
      // LogStores.sendFunctionClickLogStoresByLabel(this.view.$t('Payment.oceanExport')$t('Partners.oceanExport')$t('CargoMsg.Cargo_OceanExport')+ '-MBL-' + this.view.$t('SeaExport.CopyFromOtherBill') + '-' + this.view.$t('SeaExport.TransceiverSelection'))
    }
  }
  /**
   * 抄录MBL
   */
  onCopyHBL() {
    let hdoc = null
    const seaCargoDoc = this.job.seaCargoDoc
    if (seaCargoDoc) {
      hdoc = seaCargoDoc.find(p => p.docType === 'HBL')
    }
    if (hdoc) {
      this.form.cargoEnglishName = hdoc.cargoEnglishName
      this.form.mark = hdoc.mark
    }
  }
  /**
   * 提单类型
   */
  cmbtypeMBLChangeHandler(value) {
    const job = this.job
    const mbl2Types = [BillType.SPLIT_BILL_TYPE.code, BillType.MERGE_BILL_TYPE.code]
    if (mbl2Types.includes(job.typeMBL) && mbl2Types.includes(value) && job.typeMBL !== value) {
      this.view.$emit('resetTab', 'tabMBL2')
    }
    if (mbl2Types.includes(job.typeMBL) && job.typeMBL !== value) {
      const cargoDocArr = this.job.seaCargoDoc
      for (let i = cargoDocArr.length - 1; i >= 0; --i) {
        const item = cargoDocArr[i]
        if (item.docType === CargoDocConsts.MBL2) {
          item.deleted = true
          this.addCargoDocToModifiedSet(item)
          cargoDocArr.splice(i, 1)
        }
      }

      for (const a of this.job.seaCargoDoc) {
        if (a.docType === CargoDocConsts.MBL2) {
          console.log('a.deleted', a.deleted)
        }
      }
    }
    job.typeMBL = value
  }
  // 添加cargoDoc到被修改的集合中
  addCargoDocToModifiedSet(item) {
    const modifiedData = this.context.modifiedData
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    const oldItem = modifiedData.seaCargoDoc.find(p => p === item)
    if (oldItem) {
      Object.assign(oldItem, item)
    } else {
      modifiedData.seaCargoDoc.push(item)
    }
  }
  /**
   * 提单种类
   */
  cmbreleaseTypeMBLChangeHandler(value) {
    this.form.blNumber = Number(value) === 1 ? 'THREE' : 'ONE'
    this.form.blCopyNumber = Number(value) === 1 ? 'THREE' : 'ONE'
  }
  /**
   * 抄录收货人
   */
  onCopyConsignee(detail) {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    if (detail) {
      this.form.notifyCountry = this.form.consigneeCountry
      this.form.notifyCity = this.form.consigneeCity
      this.form.notifyProvince = this.form.consigneeProvince
      this.form.notifyZipCode = this.form.consigneeZipCode
      this.form.notifyMobile = this.form.consigneeMobile
      this.form.notifyEmail = this.form.consigneeEmail
      this.form.notifyFax = this.form.consigneeFax
      this.form.notifyContact = this.form.consigneeContact
    } else {
      this.form.notifyLine4 = this.form.consigneeLine4
      this.form.notifyLine5 = this.form.consigneeLine5
      this.form.notifyLine6 = this.form.consigneeLine6
      this.form.notifyLine7 = this.form.consigneeLine7
    }
  }
  replaceAll(source, find, replacement) {
    // return source.split(find).join(replacement)
  }
  refreshEDIFields() {
    // view.cargoDoc[_valueType + 'Contact'] = _editWindow.contact
    // view.cargoDoc[_valueType + 'Mobile'] = _editWindow.mobile
    // view.cargoDoc[_valueType + 'Fax'] = _editWindow.fax
    // view.cargoDoc[_valueType + 'Email'] = _editWindow.email
    // view.cargoDoc[_valueType + 'ZipCode'] = _editWindow.zipCode
    // view.cargoDoc[_valueType + 'City'] = _editWindow.city
    // _valueType = ''
  }
  validate6Line(s) {
    return true
  }
  /**
   * 清空收发通
   */
  onClear(type, detail) {
    CargoDocUtil.onClear(this.form, type, detail)
  }

  async paymentImportData(type) {
    CargoDocUtil.paymentImportData(this.form, type)
  }

  /**
   * CopyEnglishDescriptionOfGoodsFromReceipt
   */
  async getSlavesHBLEnglishName() {
    const list = await Job.getSlavesHBLEnglishName(this.job.uuid)
    if (list.length > 0) {
      const dList = this.setDeDuplication(list)
      this.form.cargoEnglishName = dList.join('\n\r')
    }
  }
  /**
   * 取小票唛头
   */
  async getSlavesHBLMark() {
    const list = await Job.getSlavesHBLMark(this.job.uuid)
    if (list.length > 0) {
      const dList = this.setDeDuplication(list)
      this.form.mark = dList.join('\n\r')
    }
  }
  setDeDuplication(list) {
    const dataList = []
    // 去除重复
    for (const data of list) {
      if (!dataList.includes(data)) {
        dataList.push(data)
      }
    }
    return dataList
  }
  /**
   * 取HBL信息
   */
  async getHBLInfo(type) {
    await new SeaExportJob(this.job).getSeaCargoDoc()
    let mbl = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === 'HBL') {
        mbl = doc
        break
      }
    }
    if (mbl) {
      if (type === 'mark') {
        this.form.mark = mbl.mark
      } else if (type === 'EName') {
        this.form.cargoEnglishName = mbl.cargoEnglishName
      }
    }
  }
  initOtherField() {
    const otherFieldsData = []
    otherFieldsData.push(SeaExportConstants.ALSO_NOTIFY)
    if (this.job.cargoType === 'DG') {
      otherFieldsData.push(SeaExportConstants.DGCONSIGN)
    }
    const paymentTermMblName = this.getPaymentTermNameByCode(this.job.paymentTermMBL)
    const isContainerElseWhere = paymentTermMblName && paymentTermMblName.toUpperCase().includes('ELSEWHERE')
    if (isContainerElseWhere) {
      otherFieldsData.push(SeaExportConstants.ELSE_INVOICE)
    }
    this.view.otherFieldsData = otherFieldsData
    this.view.otherSelectField = otherFieldsData[0].code
    this.otherInfoChangeHandler(this.view.otherSelectField)
  }
  getPaymentTermNameByCode(code) {
    if (this.paymentTermList) {
      const paymentTerm = this.paymentTermList.find(p => p.code === code)
      if (paymentTerm) {
        return paymentTerm.name
      }
    }
    return code
  }
  /**
   * ex excel
   */
  exportToExcel() {
    const jobNo = this.job.jobNo
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    if (cpy) {
      const isMasterJob = this.job.masterFlag && this.job.containerLoadType === 'LCL'
      ExportUtils.exportToExcelByJobNo('SeaExportJob', cpy.shortName, jobNo, isMasterJob, 'BILL_' + jobNo)
    } else {
      this.view.$message.info(this.view.$t('Message.NoTargetShippingCompanyFoundHerePleaseRefreshTheCache'))
    }
  }
  /**
   * 对单
   */
  inviteConfirmBL() {
    // CfmCargoDocPoPupUtils.getCfmBillAddress(view.cargoDoc, view, statusHistoryWaitConfirmSuccessHandler)
  }
  /**
   * 确认对单
   */
  async confirmBL() {
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
      this.view.$message.info(this.view.$t('Message.BlIsConfirmed'))
      return
    }
    this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code
    if (String(cache.config.get('ToExoSystem')) === 'TP') {
      await new SeaCargoDoc(this.form).affirmSeaCargoDoc()
    } else {
      await new SeaCargoDoc(this.form).save()
    }
    await this.confirmResultHandler()
    CargoDocUtil.syncCargoDocSftToJob(this.job, this.form)
  }
  /**
   * 邮件的Return-Path计算顺序
   * 默认用当前业务的单证人员的mail地址
   * 如果没有用当前业务的客服人员mail地址
   * 再没有就用发件人地址。
   */
  getMailFrom() {
    let user
    if (this.view.job.dc > 0) {
      user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(this.view.job.dc))
    } else if (this.view.job.csr > 0) {
      user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(this.view.job.csr))
    } else {
      user = this.view.user
    }
    return user ? user.email : ''
  }
  async statusHistoryWaitConfirmSuccessHandler() {
    await new StatusChangeHistory({
      statusType: 1, // 表示放单管理
      businessDataId: this.form.uuid,
      statusValue: CargoDocCfmState.CARGODOC_WAIT_FOR_CONFIRM
    }).save()
    await this.getCfmBillAddressHandler()
  }
  async getCfmBillAddressHandler(event = null) {
    await new SeaExportJob(this.job).getSeaCargoDoc()
    this.reloadCargoDocHandler()
  }
  async confirmResultHandler(event) {
    await new StatusChangeHistory({
      statusType: 1, // 表示放单管理
      businessDataId: this.form.uuid,
      statusValue: CargoDocCfmState.CARGODOC_CONIRMED
    }).save()
    await this.statusHistoryConfirmSuccessHandler()
  }
  async statusHistoryConfirmSuccessHandler() {
    const newDoc = await SeaCargoDoc.getSeaCargoDoc(this.form.uuid)
    if (newDoc) {
      Object.assign(this.form, newDoc)
    }
    this.getDocCfmState()
  }
  reloadCargoDocHandler() {
    this.changeJob()
    this.fillView()
  }
  /**
   * 完成补料
   */
  async completefeedClickHandler() {
    if (this.form.cfmState !== CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
      this.view.$message.warning(this.view.$t('Message.PleaseClickFirst'))
      return
    }
    const newCargoDoc = await SeaCargoDoc.completeTheFeed(this.form.uuid, this.form.version)
    if (!newCargoDoc) {
      return
    }
    Object.assign(this.form, newCargoDoc)
    await this.statusHistoryConfirmSuccessHandler()
    this.completeTheFeedHandler()
  }
  completeTheFeedHandler() {
    this.job.trackingInfo = ''
    new SeaExportJob(this.job).getTrackingInfo()
    this.getCfmBillAddressHandler()
  }
  /**
   * packing changed
   */
  async packingChange(data) {
    this.form.packing = data.value
    this.form.packingName = data.name
    this.refreshQuantitySum()
    await CargoDocUtil.syncBillToJobBySingleField(this.job, this.form, 'packing')
  }
  /**
   * quantity changed
   */
  quantityChange() {
    this.refreshQuantitySum()
    CargoDocUtil.changeBillOfLadingSynJob(this.job, this.form, true)
  }
  otherInfoChangeHandler(value) {
    switch (value) {
      case 'ALSO NOTIFY':
        this.otherField = 'alsoNotify'
        this.view.otherCode = this.form.alsoNotifyCode
        break
      case 'DGCONSIGN':
        this.otherField = 'dgconsign'
        this.view.otherCode = this.form.dgconsignCode
        break
      case 'ELSEINVOICE':
        this.otherField = 'elseInvoice'
        this.view.otherCode = this.form.elseInvoiceCode
        break
    }
  }
  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }
  /**
   * 合并HBL拆单至Mbl主单
   * @param evt
   */
  mergeHblData() {
    let markHbl = ''
    let eName = ''
    let quantityActual = 0
    let weightActual = 0
    let cubageActual = 0
    if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
      // 整合HBL拆单 件毛体 和 英文品名 唛头信息
      const _hblCargoDocs = this.job.seaCargoDoc
      for (const item_hCargoDoc of _hblCargoDocs) {
        if (item_hCargoDoc.docType === CargoDocConsts.HBL2) {
          if (markHbl) {
            markHbl += '\r'
          }
          markHbl += item_hCargoDoc.mark
          if (eName) {
            eName += '\r'
          }
          eName += item_hCargoDoc.cargoEnglishName
          quantityActual += item_hCargoDoc.quantity
          weightActual += item_hCargoDoc.weight
          cubageActual += item_hCargoDoc.cubage
        }
      }
      // MBL 英文品名 唛头被拆单整合数据覆盖
      for (const item_MCargoDoc of _hblCargoDocs) {
        if (item_MCargoDoc.docType === CargoDocConsts.MBL) {
          item_MCargoDoc.quantity = quantityActual
          item_MCargoDoc.weight = weightActual
          item_MCargoDoc.cubage = cubageActual
          item_MCargoDoc.mark = markHbl
          item_MCargoDoc.cargoEnglishName = eName
        }
      }
      this.form.mark = markHbl
      this.form.cargoEnglishName = eName
      this.form._mergeHblDataTime = new Date()
      // MBL件毛体信息 同步至基本页面件毛体
      this.job.quantityActual = quantityActual
      this.job.weightActual = weightActual
      this.job.cubageActual = cubageActual
    }
  }
  /**
   * 放单取回
   */
  async btnGetBackClickHandler() {
    this.loading = getLoading()
    try {
      if (this.form.uuid) {
        let params = null
        if (Number(this.form.bliStatus) === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code) {
          // 撤销取回
          params = {
            bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code,
            getBackDate: '',
            operation: CargoDocCfmState.CARGODOC_CANCEL_GET_BACK
            // isCancel: true // CARGO-31462 取回和撤销取回状态不对，经后端查验，该参数相关逻辑有误，删除后功能正常
          }
        } else {
          // 取回
          params = {
            bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code,
            getBackDate: new Date(),
            operation: CargoDocCfmState.CARGODOC_GET_BACK
          }
          await this.manualTriggerAndUpateFunc(null, AutomaticReleaseConstants.MBL_RETRIEVE.code)
        }
        const result = await SeaCargoDoc.updateProperties([this.form.uuid], params)
        CargoDocUtil.syncData(result['seaCargoDocs'], this.form)
        this.job.seaCargoDoc = result['seaCargoDocs']
        this.saveReleaseStateStateHandler()
      }
    } finally {
      this.loading.close()
    }
  }
  /**
   * 放单撤销
   */
  async btnReleasingClickHandler(event) {
    if (this.form.uuid && this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code) {
      // 撤销放单
      const obj = {}
      obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
      obj.releaseDate = ''
      obj.operation = CargoDocCfmState.CARGODOC_CANCEL_RETURN
      obj.surrenderedNo = ''
      obj.releaseState = CargoDocCfmState.CARGODOC_CAN_SINGLE_RELEASE
      obj.releaseBy = 0
      const result = await SeaCargoDoc.updateProperties([this.form.uuid], obj)
      this.job.seaCargoDoc = result['seaCargoDocs']
      this.saveReleaseStateStateHandler()
    } else {
      // 放单
      const releaseState = await this.checkReleaseRuleEngineState()

      // 手动触发放单规则
      if (this.form.uuid && releaseState === ReleaseState.SINGLERELEASE.code) {
        this.manualTriggerAndUpateFunc('release', AutomaticReleaseConstants.MBL_RELEASE.code)
      }
    }
  }
  async checkReleaseRuleEngineState() {
    if (!this.job.uuid) {
      return Number(this.form.releaseState)
    }

    const res = await executeRuleEngine({ jobUuid: this.job.uuid, model: 1 })
    if (res.data && Array.isArray(res.data.seaCargoDocs)) {
      this.job.seaCargoDoc = res.data.seaCargoDocs
      const currentDoc = res.data.seaCargoDocs.find(item => item.uuid === this.form.uuid)
      if (currentDoc) {
        Object.assign(this.form, currentDoc)
        this.getDocCfmState()
      }
    }
    return Number(res.data.releaseState)
  }
  async commitSurrenderedNoHandler(value) {
    const obj = {}
    obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
    obj.releaseDate = new Date()
    obj.operation = CargoDocCfmState.CARGODOC_RETURN
    obj.surrenderedNo = value.value
    obj.releaseState = ReleaseState.ONSINGLERELEASE.code
    const result = await SeaCargoDoc.updateProperties([this.form.uuid], obj)
    this.job.seaCargoDoc = result['seaCargoDocs']
    this.saveReleaseStateStateHandler()
  }
  // 修改放单状态
  async updateReleasestateFunc(uuid, releaseState) {
    const data = {
      uuid,
      releaseState
    }
    const res = await updateReleasestate(data)
    if (res.ok) {
      this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(releaseState)
    }
  }
  // 手动触发放单规则
  async manualTriggerAndUpateFunc(type, btnType) {
    const params = {
      uuid: this.form.uuid,
      state: 0,
      setting: type === 'release' ? 1 : 0,
      btnType: btnType
    }
    const res = await manualTriggerAndUpate(params)
    if (res.ok) {
      if (res.data.result === 2) {
        const messages = []
        const createElement = this.view.$createElement
        messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.businessNumber') + res.data.jobNo))
        if (res.data.mbl) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.mblNo') + res.data.mbl))
        }
        if (res.data.hbl) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.hblNo') + res.data.hbl))
        }
        if (res.data.tip.accountCompanyName) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.accountCompanyName))
        }
        if (res.data.tip.accountOverCreditLimitDate) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.view.$t('SeaExport.Exceeded'))))
        }
        if (res.data.tip.accountOverCreditLimitAmount) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.accountOverCreditLimitAmount)))
        }
        if (res.data.tip.agentCompanyName) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.agentCompanyName))
        }
        if (res.data.tip.agentOverCreditLimitDate) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.view.$t('SeaExport.Exceeded'))))
        }
        if (res.data.tip.agentOverCreditLimitAmount) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.agentOverCreditLimitAmount)))
        }
        if (res.data.tip.customerCompanyName) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.customerCompanyName))
        }
        if (res.data.tip.customerOverCreditLimitDate) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.view.$t('SeaExport.Exceeded'))))
        }
        if (res.data.tip.customerOverCreditLimitAmount) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.customerOverCreditLimitAmount)))
        }
        messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.continueOrders')))
        if (type === 'release') {
          await this.view.$confirm('', {
            title: this.view.$t('ReleaseNotes.lineCreditDialog.title'),
            message: createElement('div', null, messages),
            confirmButtonText: this.view.$t('ReleaseNotes.lineCreditDialog.confirm'),
            cancelButtonText: this.view.$t('ReleaseNotes.lineCreditDialog.cancel'),
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          }).then(() => {
            this.view.$prompt(this.view.$t('SeaExport.ReleaseOrderNumber'), this.view.$t('SeaExport.EnterReleaseNumber'), {
              confirmButtonText: this.view.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.view.$t('SeaExport.Cancel')
            }).then(value => {
              this.commitSurrenderedNoHandler(value)
              this.updateReleasestateFunc(this.form.uuid, ReleaseState.ONSINGLERELEASE.code)
            })
          }).catch(() => {
            this.updateReleasestateFunc(this.form.uuid, ReleaseState.TO_BE_COLLECTED.code)
          })
        }
      }
      if (res.data.result === 1) {
        // 满足改为可放单
        if (type === 'release') {
          this.form.releaseState = 2
        } else {
          if (this.form.releaseState !== 2) {
            this.form.releaseState = 1
          }
        }
        this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
        this.view.$message.success(this.view.$t('ReleaseNotes.lineCreditDialog.through'))
      }
      if (res.data.result === 0 && type === 'release') {
        this.view.$prompt(this.view.$t('SeaExport.ReleaseOrderNumber'), this.view.$t('SeaExport.EnterReleaseNumber'), {
          confirmButtonText: this.view.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.view.$t('SeaExport.Cancel')
        }).then(value => {
          this.commitSurrenderedNoHandler(value)
        })
      }
    }
  }
  saveReleaseStateStateHandler(e) {
    this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    this.loadCargoDoc2Handler()
  }
  carrierIsOpenMscEDI() {
    this.view.isCarrierUserMSC = false
    if (this.useMscEDICarriers) {
      const useMscEDICarrierArr = this.useMscEDICarriers.split(',')
      const carrier = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
      const scac = carrier ? carrier.scac : ''
      if (scac && scac.length > 0) {
        for (const s of useMscEDICarrierArr) {
          if (s.indexOf(scac) >= 0 && s.indexOf('1') >= 0) {
            this.view.isCarrierUserMSC = true
            break
          }
        }
      }
    }
  }
  calculateChargeWeight() {
    CargoDocUtil.calculateSEChargeWeight(this.form)
  }
  showScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  getDocCfmState() {
    const isZh = this.view.$i18n.locale === 'zh'
    const cfmState = CargoDocCfmState.getCargoDocCfmStateByCode(this.form.cfmState)
    if (cfmState) {
      this.view.lblCfrState = isZh ? cfmState.chineseName : cfmState.englishName
    }
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
    const bliStatus = CargoDocCfmState.getCargoDocBliStateByCode(this.form.bliStatus)
    if (bliStatus) {
      this.view.billLadingIssued = isZh ? bliStatus.chineseName : bliStatus.englishName
    }
  }
  refreshVessel() {
    if (this.job.barge && this.form.printParam6) {
      this.view.txtFirstVesselVoyage = this.job.bargeVessel || ''
      this.view.txtFirstVesselVoyage += ' '
      this.view.txtFirstVesselVoyage += this.job.bargeVoyage || ''
    } else {
      this.view.txtFirstVesselVoyage = this.job.vessel || ''
      this.view.txtFirstVesselVoyage += ' '
      this.view.txtFirstVesselVoyage += this.job.voyageFlight || ''
    }
  }
  /**
 * is editing
 */
  async editingChanged() {
    await this.loadJointSlaves2Handler()
  }
  /**
 * 投保
 */
  async toInsure() {
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: this.form.uuid,
      billno: this.job.mbl,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.context.config.get('isPlatformInsurance')) === 3) {
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: $store.getters.currentOfficeId,
    //     docUuid: this.form.uuid,
    //     billno: this.job.mbl,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel('MBL-' + this.view.$t('SeaExport.Insure'))
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   if (this.config.get('isPlatformInsurance') === '1') {
    //     queryIsInsured(this.job.uuid, this.form.uuid).then(result => {
    //       if (result.data) {
    //         this.view.$message.warning(this.view.$t('SeaExport.ThisSuccessfullyInsuredRepeatedAllowed'))
    //         return
    //       } else {
    //         this.view.$router.push({ name: 'PolicyDetail', query: { 'jobUuid': this.job.uuid, 'type': 'MBL', 'viewSource': 'cargo', 'officeId': $store.getters.currentOfficeId }})
    //       }
    //     })
    //   } else {
    //     let mbl = null
    //     for (const doc of this.job.seaCargoDoc) {
    //       if (doc.docType === 'MBL') {
    //         mbl = doc
    //         break
    //       }
    //     }
    //     if (Object.prototype.hasOwnProperty.call(this.job, 'containerUsages')) {
    //       for (const usage of this.job.containerUsages) {
    //         delete usage.container
    //       }
    //     }
    //     if (Object.prototype.hasOwnProperty.call(this.job, 'containers')) {
    //       for (const container of this.job.containers) {
    //         delete container.containerUsages
    //       }
    //     }
    //     SeaCargoDoc.toInsure(this.user.tenantName, mbl, this.job, this.context.office).then(data => {
    //       this.insureSuccessHandler(data)
    //     })
    //   }
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
  * 投保成功
  */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }
  /**
 * 投保按钮点击成功 日志
 * @param event
 */
  sendInsureClickLogStoresHandler(event) {
  }
  /**
 * 发货人选择
 */
  async shipperAutoCompleteChange(data, detail) {
    this.form.shipperId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      CargoDocUtil.applyShipperManifestAddress(this.form, data, detail)
    } else {
      CargoDocUtil.onClear(this.form, 1, detail)
    }
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'shipper', 1)
  }
  /**
 * 收货人选择
 */
  async consigneeAutoCompleteChange(data, detail) {
    this.form.consigneeId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      CargoDocUtil.applyConsigneeManifestAddress(this.form, data, detail)
    } else {
      CargoDocUtil.onClear(this.form, 2, detail)
    }
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
  }

  portChange(p, field) {
    const form = this.form
    form[field + 'Code'] = p.value
    form[field] = p.englishName
  }
  /**
   * alsoNotify选择
   */
  async alsoNotifyAutoCompleteChange(data) {
    if (!data) {
      return
    }
    // 判断是否原数据
    if (data.value === this.view.otherCode || data.value.toUpperCase() === this.view.otherCode) {
      return
    }
    if (data.value) {
      this.view.otherCode = data.value.toUpperCase()
      // 区分下是否手动输入 ，手动输入保留下面数据
      if (data.uuid) {
        this.form.alsoNotify = await CargoDocUtil.alsoNotifyChange(data)
      }
    } else {
      this.view.otherCode = ''
      this.form.alsoNotify = ''
    }
  }
  /**
 * 通知人选择
 */
  async notifyAutoCompleteChange(data, detail) {
    this.form.notifyId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      CargoDocUtil.applyNotifyManifestAddress(this.form, data, detail)
    } else {
      CargoDocUtil.onClear(this.form, 3, detail)
    }
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
  }
  markBlurHandler() {
    if (this.view.action !== 'edit') {
      return
    }
    const seaCargoMark = parseInt(this.config.get('seaCargoMark'))
    if (seaCargoMark === 2) {
      CargoDocUtil.changeBillOfLadingSynDoc(this.form, this.job, ['mark'], true)
    }
  }
  cargoEnglishNameBlurHandler() {
    if (this.view.action !== 'edit') {
      return
    }
    const seaCargoEnglishName = parseInt(this.config.get('seaCargoEnglishName'))
    if (seaCargoEnglishName === 2) {
      CargoDocUtil.changeBillOfLadingSynDoc(this.form, this.job, ['cargoEnglishName'], true)
    }
  }

  btnRequestReleasingClickHandler() {
    const { requestReleaseState, uuid } = this.view.form
    const uuids = [uuid]
    if (requestReleaseState === 0) {
      this.loading = getLoading()
      requestRelease(uuids).then(async res => {
        this.loading.close()
        this.view.form.requestReleaseState = 1
        await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
        this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(Number(res.data[uuid].releaseState))
        this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
      }).catch(() => {
        this.loading.close()
      })
      return
    }
    this.loading = getLoading()
    cancelRequestRelease(uuids).then(async res => {
      this.loading.close()
      this.view.form.requestReleaseState = 0
      await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
      this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    }).catch(() => {
      this.loading.close()
    })
  }

  /**
   * 检查MBL是否存在
   */
}

